import { useState, useMemo, useCallback } from 'react';
import moment from 'moment';
import useApiRequest from 'hooks/useApiRequest';
import useAsync from 'hooks/useAsync';
import { dateFormatForAPI } from 'utils/date';

const fixOpeningTimes = ({ startTime, endTime, ...rest }) => ({
  ...(startTime && endTime && startTime !== endTime
    ? {
        openingTime: startTime,
        closingTime: endTime,
      }
    : {}),
  ...rest,
});

const useVenueOpeningTimes = (date?: Date | string, venueId?: number) => {
  const [openingTimes, setOpeningTimes] = useState({});

  const apiRequest = useApiRequest();

  const requestValid = !!date && moment(date).isValid() && !!venueId;

  const dateString = useMemo(() => moment(date).format(dateFormatForAPI), [
    date,
  ]);

  const clearData = useCallback(async () => {
    setOpeningTimes({});
  }, []);

  const fetchData = useCallback(async () => {
    const { data: nextOpeningTimes } = await apiRequest.get(
      `/v1/venues/${venueId}/opening_times`,
      {
        params: { date: dateString },
      }
    );

    setOpeningTimes(fixOpeningTimes(nextOpeningTimes));
  }, [apiRequest, dateString, venueId]);

  const { loading, error, refresh } = useAsync(
    requestValid ? fetchData : clearData,
    requestValid
  );

  return { data: openingTimes, loading, error, refresh };
};

export default useVenueOpeningTimes;
